import { reportGlobalError } from './sendServerException';
const STORAGE_KEY = 'exception_generated';
let isReportingStarted = false;

// Save error to localStorage queue
function pushError(errorData) {
    // console.log('inside pushError');
    const errors = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    const isDuplicate = errors.some(e => e.message === errorData.message);
    if (!isDuplicate) {
        errors.push(errorData);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(errors));
    }
}


// Send and clear errors
function startErrorReportingLoop() {
    // console.log('inside startErrorReportingLoop');
    if (isReportingStarted) return;
    const reportErrors = () => {
        const errors = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
        // console.log('check exception reportErrors');
        console.log(errors);
        if (errors?.length > 0) {
            // console.log('inside reportErrors');
            reportGlobalError({
                exception: errors,
                username:
                    localStorage.getItem('username') !== 'undefined' &&
                        localStorage.getItem('username') !== null
                        ? localStorage.getItem('username')
                        : null,
            });
            localStorage.removeItem(STORAGE_KEY);
        }
    };
    // console.log('above reportErrors');
    reportErrors();
    setInterval(reportErrors, 300000);
    isReportingStarted = true;
}

// Global JS error handler
window.onerror = function (msg, url, lineNo, columnNo, error) {
    // console.log('inside onerror');
    pushError({
        username: localStorage.getItem('username') || null,
        message: msg,
        file: url,
        line: lineNo,
        column: columnNo,
        stack: error?.stack || '',
        userAgent: navigator.userAgent,
    });
    startErrorReportingLoop();
    return true;
};

// Global unhandled promise rejection handler
window.addEventListener('unhandledrejection', function (event) {
    // console.log('inside unhandledrejection');
    pushError({
        username: localStorage.getItem('username') || null,
        message: event.reason?.message || 'Unhandled Promise Rejection',
        file: null,
        line: null,
        column: null,
        stack: event.reason?.stack || '',
        userAgent: navigator.userAgent,
    });
    startErrorReportingLoop();
});

// Event base exception capture
window.addEventListener('error', function (event) {
    // console.log('inside window error event listener');
    if (event.target !== window) {
        const errorData = {
            username: localStorage.getItem('username') || null,
            message: `Resource load failed: ${event.target.tagName}`,
            file: event.target.src || event.target.href || null,
            line: null,
            column: null,
            stack: '',
            userAgent: navigator.userAgent,
        };
        pushError(errorData);
        startErrorReportingLoop();
    }
}, true);

// Start reporting proactively
// console.log('starting proactive error reporting loop');
startErrorReportingLoop();
